export const QUERY_KEY_HISTORY_CHATBOT = "chatbot:histories";
